import React, { useState } from 'react';
import { Star, Menu } from 'lucide-react';
import { useAppContext } from '../../context/AppContext';
import { ProfileModal } from '../common/ProfileModal';

export const Topbar = ({ onMenuClick }) => {
  const { t, lang, grade, setGrade, user, setView } = useAppContext();
  const [showProfile, setShowProfile] = useState(false);
  const [isGradeMenuOpen, setIsGradeMenuOpen] = useState(false);

  return (
    <>
      <header className="h-16 sm:h-[76px] bg-white border-b border-slate-200 flex items-center justify-between px-3 sm:px-6 md:px-8 shrink-0 z-10">
        
        <div className="flex items-center gap-1 sm:gap-2 md:gap-4 min-w-0">
          <button 
            onClick={onMenuClick}
            className="lg:hidden min-w-11 min-h-11 p-2.5 text-slate-500 hover:bg-slate-100 rounded-xl transition-colors"
            aria-label="Open menu"
          >
            <Menu size={24} />
          </button>
          <div className="relative group">
            <button
              onClick={() => setIsGradeMenuOpen(open => !open)}
              aria-expanded={isGradeMenuOpen}
              aria-haspopup="menu"
              className="flex min-h-11 items-center bg-slate-50 hover:bg-slate-100 border border-slate-200 text-slate-600 px-3 sm:px-4 py-2 rounded-xl font-semibold text-sm transition-colors whitespace-nowrap"
            >
              {t(`grade_${grade.replace('-','_')}`)}
            </button>
            <div className={`absolute top-full left-0 mt-2 w-52 sm:w-56 bg-white border border-slate-200 rounded-2xl shadow-xl transition-all flex flex-col overflow-hidden z-50 ${isGradeMenuOpen ? 'opacity-100 visible' : 'opacity-0 invisible group-hover:opacity-100 group-hover:visible'}`}>
              {['1-2', '3-4', '5-6'].map(g => (
                <button 
                  key={g} 
                  onClick={() => { setGrade(g); setView('dashboard'); setIsGradeMenuOpen(false); }}
                  className={`px-5 py-4 text-left font-bold hover:bg-slate-50 transition-colors ${grade === g ? 'text-amber-500 bg-amber-50/50' : 'text-slate-600'}`}
                >
                  {t(`grade_${g.replace('-','_')}`)}
                </button>
              ))}
            </div>
          </div>
        </div>

        <div className="flex items-center gap-2 sm:gap-6 shrink-0">
          {user.role !== 'admin' && (
            <div className="flex items-center gap-1 sm:gap-2 bg-amber-50 px-2.5 sm:px-3 py-2 rounded-full border border-amber-100">
              <Star className="text-amber-500 fill-amber-500 w-4 h-4 sm:w-5 sm:h-5" />
              <span className="font-semibold text-amber-800 text-sm tabular-nums">{user.stars}</span>
            </div>
          )}
          
          <button 
            onClick={() => setShowProfile(true)} 
            className="flex items-center gap-4 hover:bg-slate-50 p-1 sm:p-2 sm:pr-5 rounded-full transition-colors border border-transparent hover:border-slate-200"
          >
            <div className={`w-10 h-10 text-white rounded-full flex items-center justify-center font-semibold text-base ${user.role === 'admin' ? 'bg-indigo-600' : 'bg-slate-700'}`}>
              {user.name.charAt(0).toUpperCase()}
            </div>
            <div className="text-left hidden sm:block">
              <p className="max-w-[180px] truncate text-sm font-semibold text-slate-800 leading-tight" title={user.name}>{user.name}</p>
              <p className={`text-xs font-bold uppercase tracking-wider ${user.role==='admin' ? 'text-indigo-500' : 'text-slate-400'}`}>
                {user.isGuest ? t('guest') : user.role === 'admin' ? (lang === 'zh' ? '管理员' : 'Administrator') : user.role === 'teacher' ? (lang === 'zh' ? '教师' : 'Teacher') : (lang === 'zh' ? '学生' : 'Student')}
              </p>
            </div>
          </button>
        </div>
      </header>

      {showProfile && <ProfileModal onClose={() => setShowProfile(false)} />}
    </>
  );
};
